// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"111bf275","239":"29205f1e","455":"b9b7b6cb"}[chunkId] + ".chunk.js";
};